import { useIsMobile } from '../../../utils/isMobile';
import FooterMobile from './FooterMobile';
import FooterDesktop from './FooterDesktop';

export default function Footer() {
  const isMobile = useIsMobile();
  return isMobile ? <FooterMobile /> : <FooterDesktop />;
}